module.exports = __webpack_public_path__ + "media/styles/images/svg/upload-video-57b137f02e4d7b9bffad90df75a88c93.svg";